import { render, staticRenderFns } from "./punchtheclockcontent.vue?vue&type=template&id=bc122564&"
import script from "./punchtheclockcontent.vue?vue&type=script&lang=js&"
export * from "./punchtheclockcontent.vue?vue&type=script&lang=js&"
import style0 from "./punchtheclockcontent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports